import React from 'react'
import { inject, observer } from 'mobx-react'
import { DragDropProvider } from '@dnd-kit/react'
import { ConfirmDialog } from '../ManageModalControls.jsx'
import AddFieldForm from './AddFieldForm.jsx'
import FieldRow from './FieldRow.jsx'
import { getFieldName } from './fieldTypes.jsx'

// Reads and writes dataStore.userAdditionalInfoItems directly, so the Additional Information
// sidebar reflects every change made here (and vice versa) without a separate fetch.
const ManageFieldsContent = ({ dataStore, manageModalStore }) => {
  const fieldsStore = manageModalStore.fields
  const { saving, deleteItem } = fieldsStore
  const items = dataStore.userAdditionalInfoItems

  React.useEffect(() => {
    if (!deleteItem) return undefined
    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return
      event.stopImmediatePropagation()
      fieldsStore.setDeleteItem(null)
    }
    document.addEventListener('keydown', onKeyDown, true)
    return () => document.removeEventListener('keydown', onKeyDown, true)
  }, [fieldsStore, deleteItem])

  return (
    <div className='manage-modal__body manage-modal__body--tags'>
      <AddFieldForm />

      <p className='manage-modal__fields-hint'>
        <span>Drag to reorder.</span>
        <span>Fields apply to every shape, marker, folder and boundary.</span>
      </p>

      {/* Same dnd-kit setup and store action as the Additional Information sidebar. */}
      <DragDropProvider onDragEnd={event => dataStore.sortUserAdditionalInfoItems(event)}>
        <ul className='manage-modal__list manage-modal__list--status manage-modal__list--fields'>
          {items.length === 0 && (
            <li className='manage-modal__hint' style={{ listStyle: 'none', border: 0, padding: 0 }}>
              No fields yet. Add one above.
            </li>
          )}
          {items.map((item, index) => (
            <FieldRow
              key={item.id}
              item={item}
              index={index}
              onRename={(field, title) => dataStore.updateUserAdditionalInfoItem(field.id, { input: { title } })}
              onDelete={item => fieldsStore.setDeleteItem(item)}
            />
          ))}
        </ul>
      </DragDropProvider>

      {deleteItem && (
        <ConfirmDialog
          title='Delete field?'
          confirmLabel='Delete'
          confirmKind='danger'
          busy={saving}
          onCancel={() => fieldsStore.setDeleteItem(null)}
          onConfirm={() => fieldsStore.confirmDelete()}
        >
          <p>
            Deleting '{getFieldName(deleteItem)}' removes it and its values from all shapes, markers, folders and boundaries.
          </p>
        </ConfirmDialog>
      )}
    </div>
  )
}

export default inject('dataStore', 'manageModalStore')(observer(ManageFieldsContent))
